import type { API } from 'chessboard/api/config/types';
import { Game } from 'chessboard/model/game/types';

const VariantsMap: { [key: string]: Game.Variants } = {
  '3-check': Game.Variants.ThreeCheck,
  Bughouse: Game.Variants.Bughouse,
  Chess: Game.Variants.Chess,
  Chess960: Game.Variants.Chess960,
  Crazyhouse: Game.Variants.Crazyhouse,
  'King of the Hill': Game.Variants.KingOfTheHill,
};

/**
 * Create the getVariant method.
 */
export function createGetVariant(context: API.Context) {
  /**
   * Gets the chess variant.
   */
  return function getVariant(): Game.Variants {
    const { api } = context;
    const variant = api.getHeaders().Variant;

    if (!variant) {
      return Game.Variants.Chess;
    }

    return VariantsMap[variant] ?? Game.Variants.Chess;
  };
}
